import PropTypes from "prop-types"
import React, { useState } from "react"

import { useTracker } from "src/hooks/use_tracker"

import GuestSignInNudge from "./GuestSignInNudge"
import SignContractWizardContainer from "./SignContractWizardContainer"

const skipStorageKey = (quote) => `signContractNudgeSkipped:${quote.encodedId}`

const readSkipped = (quote) => {
  try {
    return sessionStorage.getItem(skipStorageKey(quote)) === "true"
  } catch (error) {
    console.error(error)
    return false
  }
}

const SignContractEntry = (props) => {
  const {
    authPhotoUrl,
    contact,
    marina,
    quote,
    signInAvailable = false,
    signInUrl,
  } = props
  const [skipped, setSkipped] = useState(() => readSkipped(quote))
  const tracker = useTracker()

  const track = (eventName) =>
    tracker.trackEvent(eventName, {
      contract_quote_id: quote.id,
      marina_id: marina.id,
      marina_name: marina.name,
    })

  const handleSignIn = () => track("contracts_v2:sign_in_nudge_accepted")

  const handleSkip = () => {
    track("contracts_v2:sign_in_nudge_skipped")
    try {
      sessionStorage.setItem(skipStorageKey(quote), "true")
    } catch (error) {
      console.error(error)
    }
    setSkipped(true)
  }

  if (signInAvailable && !skipped) {
    return (
      <GuestSignInNudge
        authPhotoUrl={authPhotoUrl}
        contact={contact}
        onSignIn={handleSignIn}
        onSkip={handleSkip}
        signInUrl={signInUrl}
      />
    )
  }

  return <SignContractWizardContainer {...props} />
}

SignContractEntry.propTypes = {
  authPhotoUrl: PropTypes.string,
  contact: PropTypes.shape({
    firstName: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
  }).isRequired,
  marina: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    name: PropTypes.string,
  }).isRequired,
  quote: PropTypes.shape({
    id: PropTypes.number,
    encodedId: PropTypes.string.isRequired,
  }).isRequired,
  signInAvailable: PropTypes.bool,
  signInUrl: PropTypes.string,
}

export default SignContractEntry
